/* eslint-env browser */

'use strict';

const { h } = require('phy');
const CheckCircleSolid = require('@design-system/svg-icons/preact/CheckCircleSolid')
  .default;
const Error = require('@design-system/svg-icons/preact/Error').default;

const { APPLIED, ERROR } = require('../../constants');
const ApplyPromoCodeComponent = require('../../components/apply_promo_code_component');
const ApplyPromoCodeContainer = require('../apply_promo_code_container');
const NotificationContainer = require('../notification_container');

class ApplyPromoCodeContainerDesktop extends ApplyPromoCodeContainer {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    switch (this.state.promoApplied) {
      case APPLIED: {
        return h(
          '.success-container',
          h(CheckCircleSolid),
          h(NotificationContainer, {
            ...this.props,
            bhw: 'ClickToApplyPromoCodeInfo',
            messageText: this.state.successMessage,
            notificationKlass: this.state.notificationKlass,
            key: String(this.notificationCounter),
          })
        );
      }
      case ERROR: {
        return h(
          '.apply-code-error-wrapper',
          h(ApplyPromoCodeComponent, {
            ...this.props,
            handleApplyClick: this.handleApplyClick,
          }),
          h(
            '.error-container',
            h(Error),
            h(NotificationContainer, {
              ...this.props,
              bhw: 'ClickToApplyPromoCodeError',
              messageText: this.state.errorMessage,
              notificationKlass: this.state.notificationKlass,
              key: String(this.notificationCounter),
            })
          )
        );
      }
      default: {
        return h(ApplyPromoCodeComponent, {
          ...this.props,
          handleApplyClick: this.handleApplyClick,
        });
      }
    }
  }
}

module.exports = ApplyPromoCodeContainerDesktop;
